var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.size + 'px', width: _vm.size + 'px' })},[_c('lottie',{attrs:{"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }